import { render } from "./SimpleLayout.vue?vue&type=template&id=c8da06e4"
import script from "./SimpleLayout.vue?vue&type=script&lang=js"
export * from "./SimpleLayout.vue?vue&type=script&lang=js"

import "./SimpleLayout.vue?vue&type=style&index=0&id=c8da06e4&lang=css"
script.render = render

export default script